<script lang="ts">
    import { Datatable } from "svelte-simple-datatables";
    import { Col } from "sveltestrap";
    import { OrderHistory} from "../../../../utils/Constant/Constant";
    import { tableData } from "../../../../Data/Ecommerce/OrderHistory/DataTable";
    import Card from "../../../Core/Card.svelte";
    import DatatableBody from "./DatatableBody.svelte";
    import DatatableHeader from "./DatatableHeader.svelte";
    const settings = {
        blocks: {
            searchInput: false, 
        },
        pagination: true,
        scrollY: true,
        scrollX: true,
        rowsPerPage: 9,
        sortable: true,
    };
    let rows:any;
</script>

<Col sm="12">
    <Card headerTitle={OrderHistory} cardHeaderprops="pb-0">
        <div slot="contentbody">
            <div class="order-history table-responsive">
                <Datatable
                    {settings}
                    class="display"
                    data={tableData}
                    bind:dataRows={rows}
                >
                    <thead>
                        <DatatableHeader />
                    </thead>
                    <tbody>
                        <DatatableBody rows={rows} />
                    </tbody>
                </Datatable>
            </div>
        </div>
    </Card>
</Col>
